module.exports = __webpack_public_path__ + "img/banner.bfcf0214.jpg";